// Получение ближайшей даты по дню недели
// Обязательные поля: текущая дата, день недели

const getNextDayOfWeek = (datePayload: Date, dayOfWeek: number): Date => { 
    const currentDate =  new Date(datePayload);
    const currentDay = currentDate.getDay();
    if (currentDay === dayOfWeek) {
        return currentDate;
    }
    const daysUntilNext = (dayOfWeek + 7 - currentDay) % 7;
    currentDate.setDate(currentDate.getDate() + (daysUntilNext || 7 ));
    return currentDate;
}

export default getNextDayOfWeek;